import { Icon } from "@iconify/react";
import clsx from "clsx";
import { ComponentProps, FC, useEffect, useState } from "react";
import useCloseOnEscape from "../../hooks/useCloseOnEscape";

const SlideModal: FC<
  ComponentProps<"div"> & {
    isOpen: boolean;
    close: () => void;
    fitEnd?: boolean;
    wrapperClassname?: string;
  }
> = ({ children, isOpen, close, title, wrapperClassname }) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => setIsActive(isOpen), [isOpen]);

  const onClose = () => {
    setIsActive(false);
    setTimeout(() => close(), 300);
  };

  useCloseOnEscape(isOpen, onClose);

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-50 bg-darkest/20">
          <div
            className={clsx(
              "absolute transition-all will-change-auto ease-in-out h-full flex flex-col duration-300 bg-white inset-0 left-auto",
              !wrapperClassname
                ? `w-full sm:w-2/3 lg:w-1/2 xl:w-5/12 2xl:max-w-2xl `
                : wrapperClassname,
              isActive
                ? "translate-x-0 opacity-100"
                : "translate-x-full opacity-0"
            )}
          >
            <div className="flex items-center h-16 gap-3 px-4 border-b md:px-8">
              <p className="w-full text-lg font-bold">{title}</p>
              <button
                type="button"
                aria-label="Close modal"
                className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-red-50 text-xl text-red-600 transition-colors hover:bg-red-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                onClick={onClose}
              >
                <Icon icon="tabler:x" />
              </button>
            </div>
            <div className="flex-grow flex flex-col items-stretch overflow-auto p-4 md:p-8 mb-8">
              {children}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SlideModal;
